import { ODSViewportSize } from "@/utils";
import {
  ODSBreadcrumbGroup,
  ODSBreadcrumbGroupsOptions,
  ODSBreadcrumbItemProps,
} from "./ODSBreadcrumb.types";

export { generateBreadcrumbGroupsOptions, generateBreadcrumbGroups };

function generateBreadcrumbGroupsOptions(
  viewportSize: ODSViewportSize
): ODSBreadcrumbGroupsOptions {
  if (viewportSize === "small") return { maximumItems: 3, secondGroupItems: 1 };
  return { maximumItems: 6, secondGroupItems: 3 };
}

function generateBreadcrumbGroups(
  items: ODSBreadcrumbItemProps[],
  options?: ODSBreadcrumbGroupsOptions
): Partial<Record<ODSBreadcrumbGroup, ODSBreadcrumbItemProps[]>> {
  const maximumItems = options?.maximumItems ?? 6;
  if (items?.length < maximumItems) return { firstGroup: items };
  const firstGroupItems = options?.firstGroupItems ?? 1;
  const secondGroupItems = options?.secondGroupItems ?? 3;
  const firstGroupEndIndex = firstGroupItems;
  const overflowGroupEndIndex = items.length - secondGroupItems;
  const secondGroupEndIndex = items.length;
  return {
    firstGroup: items.slice(0, firstGroupEndIndex),
    overflowGroup: items.slice(firstGroupEndIndex, overflowGroupEndIndex),
    secondGroup: items.slice(overflowGroupEndIndex, secondGroupEndIndex),
  };
}
